import { Routes } from "@angular/router";
import { authGuard } from "../../../core/guards/auth.guard";
import { DevelopmentPageComponent } from "./development-page.component";

export const developmentPageRoutes: Routes = [
  {
    path: 'development',
    canActivate: [authGuard],
    component: DevelopmentPageComponent
  }
]
